<template>
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.0098 4.51658C11.8099 3.22765 10.8818 2.35742 9.48302 2.35742H4.9458C3.36628 2.35742 2.37402 3.47933 2.37402 5.06418V9.33747C2.37402 10.7813 3.19925 11.8452 4.55225 12.013"
      stroke="#FAFAFA"
      stroke-width="1.17857"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.9119 6.81934H9.3762C7.79593 6.81934 6.80444 7.9382 6.80444 9.52228V13.7956C6.80444 15.3797 7.79059 16.4986 9.3762 16.4986H13.9111C15.4975 16.4986 16.4837 15.3797 16.4837 13.7956V9.52228C16.4837 7.9382 15.4975 6.81934 13.9119 6.81934Z"
      stroke="#FAFAFA"
      stroke-width="1.17857"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
